import React, { Component, PureComponent } from "react";
import moment from "moment";
import {
  ResponsiveContainer,
  Legend,
  ComposedChart,
  BarChart,
  Bar,
  Cell,
  ReferenceLine,
  CartesianGrid,
  Line,
  LineChart,
  XAxis,
  YAxis,
  Tooltip
} from "recharts";

import { getRange, Button, ButtonGroup, Dropdown } from "aible";
import numeral from "numeral";

import equal from "fast-deep-equal";

import { Modal, Popover, OverlayTrigger } from "react-bootstrap";

import Select from "react-select";

import FirstVarIcon from "images/Next-Icons/drill-in-2.svg";
import SecondVarIcon from "images/Next-Icons/drill-in-1.svg";
import MicroscopeIcon from "images/Microscope.svg";
import TelescopeIcon from "images/Next-Icons/mode-voting.svg";
import StatAssocIcon from "images/Next-Icons/stats.svg";
import PopularIcon from "images/Next-Icons/mode-voting.svg";
import VotingIcon from "images/Next-Icons/model-voting.svg";
import EditNotepadIcon from "images/Next-Icons/EditNotepadIcon.svg";
import TodoFeedbackIcon from "images/Next-Icons/TodoFeedbackIcon.svg";

import LeakageChartContainer from "containers/Next/Charts/LeakageChart";

import * as nextReducer from "containers/Next/NextReducer";

import Heatmap from "components/Next/Charts/Heatmap";

import styles from "./style.module.css";
import { ChartSeriesType } from "utils/insight/types";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { rgb } from "d3-color";

class CustomizedAxisTick extends PureComponent {
  render() {
    const { x, y, stroke, payload } = this.props;

    const pIndex = payload?.index;

    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={-5} dx={10} opacity={1} textAnchor="start" fontWeight={undefined} fill={"#666"}>
          {payload.value.length > 45 ? payload.value.substring(0, 45) + "..." : payload.value}
        </text>
      </g>
    );
  }
}

export default class MuscleBarChart extends PureComponent {
  renderTinyScore(node) {
    const { id } = this.props;

    return (
      <div className={styles.tinyMuscleScoreDash}>
        <LeakageChartContainer id={id} height={110} width={110} innerRadius={13} node={node} isTiny hideChords />
        <div className={styles.tinyScore}>{node?.rank + 1}</div>
      </div>
    );
  }

  render() {
    const { chart, quickSearch } = this.props;

    const retChart = chart.filter((c) => c.value > 0).sort((a, b) => b.value - a.value);

    let ownColor = "gray";

    chart &&
      chart.forEach((c) => {
        if (c?.currKeys?.[0] && c?.currKeys?.[0] === c?.currKeys?.[1]) {
          ownColor = c?.color;
        }
      });

    return (
      <div style={{ paddingTop: "10px" }}>
        <div
          className={styles.chartTitleSmall}
          style={{ background: rgb(ownColor).copy({ opacity: 0.1 }), minHeight: "20px" }}
          onClick={() => quickSearch(chart?.[0]?.currKeys?.[0])}
        >
          {chart?.[0]?.currKeys?.[0]}
        </div>
        <BarChart
          layout={"vertical"}
          height={27 * retChart.length}
          width={300}
          margin={{ left: -21 }}
          data={retChart}
          barSize={3}
        >
          <XAxis type="number" hide />
          <YAxis dataKey="sText" type="category" tick={<CustomizedAxisTick />} tickLine={false} width={20} />
          <Tooltip cursor={false} />
          <Bar dataKey="value">
            {retChart.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
      </div>
    );
  }
}
